import { RPPRepository } from '@/core/repositories/rpp.repository'
import {
    GetLtlRppDetailsResponse,
    GetLtlRppParams,
    GetLtlRppResponse,
    GetLtlRppBidResponse,
    RPPCashFlowsListResponseT,
    RPPExportExcelPayloadT,
    RPPExportExcelResponseT,
    RPPListParamsT,
    RPPListResponseT,
    RPPOrdersListParamsT,
    RPPOrdersListResponseT,
    RPPPayloadT,
    RPPResponseT,
    RppSubmitPayload,
    GetLtlRppCostComparisonResponse,
} from '@/core/types/rpp.types'

const rppRepository = new RPPRepository()

export class RPPService {
    async getCashFlows(): Promise<RPPCashFlowsListResponseT> {
        const response = await rppRepository.getCashFlows()
        return response.data
    }

    async getRPPOrdersList(params: RPPOrdersListParamsT): Promise<RPPOrdersListResponseT> {
        const response = await rppRepository.getRPPOrdersList(params)
        return response.data
    }

    async getRPPList(params: RPPListParamsT): Promise<RPPListResponseT> {
        const response = await rppRepository.getRPPList(params)
        return response.data
    }

    async getRPP(id: number): Promise<RPPResponseT> {
        const response = await rppRepository.getRPP(id)
        return response.data
    }

    async createRPP(payload: RPPPayloadT): Promise<void> {
        await rppRepository.createRPP(payload)
    }

    async submitRpp(payload: RppSubmitPayload): Promise<void> {
        const response = await rppRepository.submitRpp(payload)
        return response.data
    }

    async editRPP(payload: RPPPayloadT): Promise<void> {
        const response = await rppRepository.editRPP(payload)
        return response.data
    }

    async changeCompany(id: number, companyId: number): Promise<void> {
        await rppRepository.changeCompany(id, companyId)
    }

    async changeStatusRPP(rpp_id: number, status_code: string): Promise<void> {
        await rppRepository.changeStatusRPP(rpp_id, status_code)
    }

    async exportExcel(params: RPPExportExcelPayloadT): Promise<RPPExportExcelResponseT> {
        const response = await rppRepository.exportExcel(params)
        return response.data
    }

    async exportLTLExcel(params: RPPExportExcelPayloadT): Promise<RPPExportExcelResponseT> {
        const response = await rppRepository.exportLTLExcel(params)
        return response.data
    }

    async exportLtlByIdExcel(id: number): Promise<RPPExportExcelResponseT> {
        const response = await rppRepository.exportLtlByIdExcel(id)
        return response.data
    }

    async deleteRpp(id: number): Promise<void> {
        const response = await rppRepository.deleteRpp(id)
        return response.data
    }

    async getLtlRppList(params: GetLtlRppParams): Promise<GetLtlRppResponse> {
        const response = await rppRepository.getLtlRppList(params)
        return response.data
    }

    async getLtlRppCostComparison(id: number): Promise<GetLtlRppCostComparisonResponse> {
        const response = await rppRepository.getLtlRppCostComparison(id)
        return response.data
    }

    async getLtlRpp(ltl_rpp_id: number): Promise<GetLtlRppDetailsResponse> {
        const response = await rppRepository.getLtlRpp(ltl_rpp_id)
        return response.data
    }

    async getLtlRppBid(trip_id: number): Promise<GetLtlRppBidResponse> {
        const response = await rppRepository.getLtlRppBid(trip_id)
        return response.data
    }
}
